<ng-container *transloco="let t">
    <div class="bazis-browse-default__title">
        <ng-container *ngIf="titleKey || title">{{
            t(titleKey, titleParams) || title
        }}</ng-container>
        <ng-content select="title"></ng-content>
    </div>
    <div
        *ngIf="value !== undefined; else tplNoValue"
        class="bh-flex bh-align-items-center"
    >
        {{ value }}
        <ng-container *ngIf="unitKey">{{ t(unitKey) }}</ng-container>
        <ng-container *ngIf="isEditable">
            <bazis-button
                fill="clear"
                color="action"
                size="mini"
                class="bh-margin-start-2x"
                (click)="edit.emit()"
            >
                <bazis-icon
                    [name]="icons.edit"
                    slot="icon-only"
                ></bazis-icon>
            </bazis-button>
        </ng-container>
    </div>
    <ng-template #tplNoValue>
        <div class="bh-flex bh-align-items-center">
            <ng-content></ng-content>
        </div>
    </ng-template>
</ng-container>
